import { render, staticRenderFns } from "./honorRoll.vue?vue&type=template&id=6e4d1918&scoped=true"
import script from "./honorRoll.vue?vue&type=script&lang=js"
export * from "./honorRoll.vue?vue&type=script&lang=js"
import style0 from "./honorRoll.vue?vue&type=style&index=0&id=6e4d1918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d1918",
  null
  
)

export default component.exports